/**
 * whitelist.js
 *
 * This is an interface for creating logic gates based on user privileges.
 */
(function(win) {

  // A reference to the utils collection.
  var utils = win.slideshare_object.utils;

  /**
   * Creates Whitelist instances for specified privilege groups.
   * @param {string|array} groups The group(s) to whitelist.
   * @constructor
   */
  function Whitelist(groups) {
    this._groups = this._validateGroups(groups);
  }

  Whitelist.prototype = /** @lends Whitelist.prototype */ {

    /**
     * Determines if the whitelist contains valid groups.
     * @returns {boolean} Are there valid groups in this whitelist?
     */
    isValid: function() {
      return this._groups.length > 0;
    },

    /**
     * Determines whether or not the user is a member of at least one of
     * the whitelist groups.
     * @returns {boolean} Is the user a group member?
     */
    containsUser: function() {
      return this._groups.some(function(group) {
        var method = this._getValidationMethod(group);
        return method && method.call(this);
      }, this);
    },

    /**
     * Prunes a group or collection of groups, removing invalid entries.
     * @param {string|array} groups The group(s) to validate.
     * @returns {array} A collection of valid groups derived from the given groups.
     * @private
     */
    _validateGroups: function(groups) {
      groups = utils.isArray(groups) ? groups : [groups];
      return groups.filter(function(group) {
        return Whitelist.GROUPS.indexOf(group) !== -1;
      });
    },

    /**
     * Fetches a reference to a method to validate whether or not the user is a member of a specific group.
     * Each group listed in Whitelist.GROUPS should have it's own validation method defined using this format:
     *    _userIs + camelCased group name
     * @param {string} group The group to fetch a validation method for.
     * @returns {function} The method used to validate whether the user is a member of the passed group.
     * @private
     */
    _getValidationMethod: function(group) {
      return this['_userIs' + group.charAt(0).toUpperCase() + group.slice(1)];
    },

    /**
     * Fetches a reference to the user object.
     * @returns {object} The global user object.
     * @private
     */
    _getUser: function() {
      return win.slideshare_object.user;
    },

    /**
     * A validation method to determine if the user is a super user.
     * @returns {boolean} Is the user a super user?
     * @private
     */
    _userIsSuperuser: function() {
      var user = this._getUser();
      return user && user.su;
    },

    /**
     * A validation method to determine if the user is a LinkedIn employee.
     * @returns {boolean} Is the user a LinkedIn employee?
     * @private
     */
    _userIsCompany: function() {
      var user = this._getUser();
      return user && user.li;
    }

  };

  // All valid group options.
  Whitelist.GROUPS = ['superuser', 'company'];

  // Export the Whitelist object.
  utils.exports('Whitelist', Whitelist);

}(window));
